import request from "../request";

/**
 * 获取HSE用户信息
 * @param {*} params
 * @returns
 */
export const hseInfo = (id) => {
  return request({
    url: `/hse/hse/info/${id}`,
    method: "get",
  });
};
/**
 * 报告获取图片
 * @param {*} data
 * @returns
 */
export const reportApi = (data) => {
  return request({
    url: "/report/items/list",
    method: "get",
    params: data,
  });
};

// 查询设备信息记录列表
export function listEquipment(query) {
  return request({
    url: "/equipment/list",
    method: "get",
    params: query,
  });
}

// 新增设备巡检日志
export function addInspect(data) {
  return request({
    url: "/equipment/inspect",
    method: "post",
    data: data,
  });
}

// 新增设备故障日志
export function addFault(data) {
  return request({
    url: "/equipment/fault",
    method: "post",
    data: data,
  });
}

// 新增设备维修记录
export function addRepair(data) {
  return request({
    url: "/equipment/repair",
    method: "post",
    data: data,
  });
}

export function listBorrow(query) {
  return request({
    url: '/equipment/borrow/list',
    method: 'get',
    params: query
  })
}

export function borrow(data) {
  return request({
    url: "/equipment/borrow/borrow",
    method: "post",
    data: data,
  });
}

export function lend(data) {
  return request({
    url: "/equipment/borrow/lend",
    method: "post",
    data: data,
  });
}

export function listYtcert(query) {
  return request({
    url: '/hse/ytCert/list',
    method: 'get',
    params: query
  })
}

export function getWxConfigParams(query) {
  return request({
    url: '/hse/ytCert/wxConfig',
    method: 'post',
    data: query
  })
}